import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import standardroom from "../images/standard.jpg"
import deluxeroom from "../images/Deluxe room_vihan.jpg";
import Superdeluxe from "../images/Super Deluxe room.jpg";
import suitroom from "../images/Suit Room.jpg";
import cottageroom from "../images/Cottage_room.jpg";
import cafe from "../images/cafe_vilas club resort.jpg";
import vintagecafe from "../images/cafe.jpg";
import familyroom from "../images/Family room-Vilas.jpg"
import multicuisine from "../images/Multicuisine Restaurants.jpg";
import restaurant_berhampore from "../images/Restro Reception new 2.jpg";
import ScrollToTop from "react-scroll-to-top";
import "./Home.css";
import Gallery from './Gallery';
import Corporate from './Corporate';
// import Room from './Room';


function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
   
      <div className='album py-1'>
        <div className='container'>
          <h5>Best Hotel in Berhampore</h5>
          </div>
          </div>
      <Slider />
       <div className='roomdiscount'>
          <div className="album py-0">
        <div className="container">
           <marquee>
          <h3 style={{color:"white"}} className='mt-3'><b>Welcome to VILA'S CLUB RESORT - ✨ Experience Comfort, Class & Calmness at VILA'S CLUB RESORT ✨</b></h3> </marquee>
          </div>
          </div>
        </div>
     
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px" }} className="fixed-bottom shadow mb-1">

        <a className='vevaroom shadow' href='tel: 9046258702'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style={{ color: "maroon" }} fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
        </svg> <b>Call with Us</b></a>
      </div>

 
       
      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>Stay at <b>Vila's Club Resort</b></h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
       
<div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='cottage-room'>
                  <div className="card" >
                    <img src={standardroom} className="card-img-top" alt="standardroom"/>
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}} className="card-title ">Standard Room</h5>
                      <p className="card-text mb-1">ROOM NO. V-03, VR-04, VR-101, VR-102, </p>
                       <div className="price-buttons mb-3">
          <button>
            Single Occupancy
            <span className='mb-0'>₹1000-1800/-</span>
          </button>
          <button>
            Double Occupancy
            <span className='mb-0'>₹1500-2200/-</span>
          </button>
       </div>
                      <a href="#" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
               <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='#'>
                  <div className="card" >
                    <img src={deluxeroom} className="card-img-top" alt="Premiumroom" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title">Premium Room</h5>
                      <p className="card-text mb-1">ROOM NO. - 206, 208, 209</p>
                      <div className="price-buttons mb-1">
          <button>
            Single Occupancy
            <span className='mb-0'>₹1800/-</span>
          </button>
          <button>
            Double Occupancy
            <span className='mb-0'>₹2200/-</span>
          </button>
       </div>
       <p className='mb-2'>Extra Person - 800/-</p>
                      <a href="#" className="button mt-2"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='cottage-room'>
                  <div className="card" >
                    <img src={cottageroom} className="card-img-top" alt="cottageroom" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title">Cottage Room</h5>
                      <p className="card-text">ROOM NO. - C-01,  C-02</p>
                                              <div className="price-buttons mb-3">
          
          <button>
            Double Occupancy
            <span className='mb-0'>₹2400/-</span>
          </button>
       </div>
                  
                      <a href="cottage-room" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='deluxe-room'>
                  <div className="card" >
                    <img src={deluxeroom} className="card-img-top" alt="deluxeroom" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title">Deluxe Room</h5>
                      <p className="card-text">ROOM NO. - 201, 202, 301, 302</p>
                        <div className="price-buttons mb-3">
          <button>
            Single Occupancy
            <span className='mb-0'>₹2400/-</span>
          </button>
          <button>
            Double Occupancy
            <span className='mb-0'>₹2600/-</span>
          </button>
       </div>
                        
                      <a href="deluxe-room" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>


            <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='Super-deluxe-room'>
                  <div className="card" >
                    <img src={Superdeluxe} className="card-img-top" alt="Superdeluxe" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title">Super Deluxe Room</h5>
                      <p className="card-text">ROOM NO. - 203, 204, 303, 304</p>
                              <div className="price-buttons mb-1">
          <button>
            Single Occupancy
            <span className='mb-0'>₹3000/-</span>
          </button>
          <button>
            Double Occupancy
            <span className='mb-0'>₹3200/-</span>
          </button>
       </div>
       <p className='mb-2'>Extra Person - 800/-</p>
                      <a href="Super-deluxe-room" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='Suitroom'>
                  <div className="card" >
                    <img src={suitroom} className="card-img-top" alt="suitroom" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title">Suit Room</h5>
                      <p className="card-text">ROOM NO. 306</p>
                        <div className="price-buttons mb-1">
          <button>
            Double Occupancy
            <span className='mb-0'>₹4200/-</span>
          </button>
         
       </div>
       <p className='mb-2'>Extra Person - 800/-</p>
                      <a href="Suitroom" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>

          <div className="col-md-4 mt-4">
              <div className='homecard'>
                <a href='family-room'>
                  <div className="card" >
                    <img src={familyroom} className="card-img-top" alt="suitroofamilyroom" />
                    <div className="card-body">
                      <h5 style={{color:"#80490d"}}  className="card-title mb-2">Family Room</h5>
                      <p className="card-text mb-1">ROOM NO. 210</p>
                        <div className="price-buttons mb-1">
                           <button>
            Single Occupancy
            <span className='mb-0'>₹6000/-</span>
          </button>
          <button>
            Double Occupancy
            <span className='mb-0'>₹6300/-</span>
          </button>
         
       </div>
       <p className='mb-2'>Extra Person - 500/-</p>
                      <a href="family-room" className="button mt-3"><span>Learn More</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>FAMOUS <b>VINTAGE CAFE</b> at Berhampore</h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={cafe} className="card-img-top" alt="best cafe murshidabad" />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={vintagecafe} className="card-img-top" alt="vintagecafe_berhampore" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-end mb-0">
            <a href='Vintagecafe'>
              <button className='morephoto mt-3'>More Photo & Menu <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg></button>
            </a>
          </div>
        </div>
      </div>
      <br />

      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>FAMOUS <b>MULTICUISINE RESTAURANT</b> at Berhampore</h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={restaurant_berhampore} className="card-img-top" alt="restaurant_berhampore murshidabad" />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={multicuisine} className="card-img-top" alt="multicuisine restaurant_berhampore" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-end mb-0">
            <a href='multicuisine-menu'>
              <button className='morephoto mt-3'>More Photo & Menu <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg></button>
            </a>
          </div>
        </div>
      </div>
      <br />

      <div className="containerse">

        <br />
        <br />
        <br />
        <br />

        <div className='contact'>
          <h1 ><b>Vila's Club Resort</b></h1><br />
          <br />
          <br />

        </div>
      </div>
      <br />
      <div className='album py-0'>
        <div className='container'>
          <div className='gallery'>
            <h1><b>VILA'S CLUB RESORT Gallery</b></h1>
          </div>
        </div>
      </div>
      <Gallery />
      {/* <Newgallery/> */}
      <br />
      <br />
      <Corporate />
      <br />

    </div>
  )
}

export default Home